export const DEFAULT_COORDINATES = { x: 0, y: 0 }

export const getElementRectBySelector = (selector: string) =>
  document.querySelector(selector)
    ? document.querySelector(selector)?.getBoundingClientRect()
    : null

export const getCenterFromElementRect = ({
  x,
  y,
  width,
  height,
}: {
  x: number
  y: number
  width: number
  height: number
}) => ({
  x: window.scrollX + x + width / 2,
  y: window.scrollY + y + height / 2,
})

export const getBottomFromElementRect = ({
  x,
  y,
  width,
  height,
}: {
  x: number
  y: number
  width: number
  height: number
}) => ({
  x: window.scrollX + x + width / 5,
  y: window.scrollY + y + height,
})

export const getTopFromElementRect = ({
  x,
  y,
  width,
}: {
  x: number
  y: number
  width: number
}) => ({
  x: window.scrollX + x + width / 5,
  y: window.scrollY + y,
})

export const getViewportRect = () => ({
  left: window.scrollX,
  top: window.scrollY,
  right: window.scrollX + window.innerWidth,
  bottom: window.scrollY + window.innerHeight,
  center: window.scrollY + window.innerHeight / 2,
})

export const getTooltipDirection = (
  {
    x,
    y,
  }: {
    x: number
    y: number
  },
  tooltipWidth: number,
) => {
  const viewportRect = getViewportRect()
  let direction

  if (y < viewportRect.center) {
    direction = 'top'
  } else {
    direction = 'bottom'
  }

  if (viewportRect.right > tooltipWidth * 1.5) {
    if (x < 0 + tooltipWidth) {
      direction += '-left'
    } else if (x > viewportRect.right - tooltipWidth) {
      direction += '-right'
    }
  }

  return direction
}

export const getTooltipLocation = (selector: string, arrowDirection: string) => {
  const elementRect = getElementRectBySelector(selector)
  const getDirectionFunction = arrowDirection.includes('top')
    ? getBottomFromElementRect
    : getTopFromElementRect

  return elementRect ? getDirectionFunction(elementRect) : DEFAULT_COORDINATES
}

export const getTransformOffset = (direction: string) => {
  let x = -50
  let y = 0

  if (direction.includes('bottom')) {
    y = -100
  }

  if (direction.includes('right')) {
    x = -90
  } else if (direction.includes('left')) {
    x = -20
  }

  return { x, y }
}

export const getSpotlightLocation = (selector: string) => {
  const elementRect = getElementRectBySelector(selector)

  return elementRect ? getCenterFromElementRect(elementRect) : DEFAULT_COORDINATES
}

export const getTooltipProperties = (selector: string, width: number) => {
  const elementRect = getElementRectBySelector(selector)
  const elementCenter = elementRect ? getCenterFromElementRect(elementRect) : DEFAULT_COORDINATES
  const arrowDirection = getTooltipDirection(elementCenter, width)
  const location = getTooltipLocation(selector, arrowDirection)
  const offset = getTransformOffset(arrowDirection)

  return {
    style: {
      top: `${location.y}px`,
      left: `${location.x}px`,
      transform: `translate(${offset.x}%, ${offset.y}%)`,
      width,
    },
    arrow: arrowDirection,
  }
}

export const isElementHidden = (selector: string) =>
  document.querySelector(selector)
    ? document.querySelector<HTMLElement>(selector)?.offsetParent === null
    : true
